import React from 'react';
import { useSelectCurrentOrderId } from 'selectors/order/selectCurrentOrder';
import { assertDefined } from 'utilities/Assertions';
import { useGetDetailedEscrowDataQuery, useMarkFundingCompletedMutation } from 'API/order/escrow/EscrowBaseAPI';
import { FundingComplete } from './FundingComplete';
import { checkForMutationSuccess } from 'API/checkForMutationSuccess';
import { useGetFpeStatusesDataQuery } from 'API/order/fpeStatus/FpeStatusAPI';
import { useHasPermissions } from '../../accessControl/hooks/useHasPermissions';
import { useAppDispatch } from 'store/store';
import { loadOrderAsyncAction } from '../../../store/order/batchedDispatches';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';

export interface IFundingCompleteContainerProps {}

export const FundingCompleteContainer: React.FC<IFundingCompleteContainerProps> = () => {
  const dispatch = useAppDispatch();
  const orderId = useSelectCurrentOrderId();
  assertDefined(orderId);
  const { data: order } = useGetDetailedEscrowDataQuery(orderId);

  const { data, isLoading } = useGetFpeStatusesDataQuery(orderId);

  const [markFundingComplete, { isLoading: isLoadingComplete }] = useMarkFundingCompletedMutation();
  const hasEditPermission = useHasPermissions([ePermissions.EscrowFundingCompletedEdit]);

  const onCompleteFunding = async () => {
    const result = await markFundingComplete({ orderId });
    if (checkForMutationSuccess(result, 'setting funded at')) {
      await dispatch(loadOrderAsyncAction(orderId));
    }
  };

  return (
    <FundingComplete
      hasEditPermission={hasEditPermission}
      fundedAt={data?.fundingComplete.updatedAt || order?.fundedAt || undefined}
      fundedBy={data?.fundingComplete.updatedBy}
      isLoading={isLoading || isLoadingComplete}
      onCompleteFunding={onCompleteFunding}
    />
  );
};
